import React, { useState, useEffect } from 'react';
import { HttpStatusCode } from '@/fetch/core/constant';
import { message } from 'antd';
import { CommonResponse, CommonTableResponse } from './type';
export const isNullObject = (obj: any) => {
  if (!obj) {
    return true;
  }
  return Object.keys(obj).length === 0;
};
export function useTableData<T, U>(
  searchOptions: T,
  fetchData: (options: T) => Promise<CommonResponse<CommonTableResponse<U>>>,
  tableKey?: string,
): {
  tableData: CommonTableResponse<U> | null;
  loading: boolean;
  reloadTable: () => void;
} {
  const [responseData, setResponseData] =
    useState<CommonTableResponse<U> | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const reloadTable = () => {
    getData();
  };
  const getData = async () => {
    setLoading(true);
    try {
      const res = await fetchData(searchOptions);
      if (res.code === HttpStatusCode.Success) {
        if (!isNullObject(res.data)) {
          setResponseData(res.data);
        } else {
          message.error(res.message);
        }
      } else {
        message.error(res.message);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getData();
  }, [JSON.stringify(searchOptions), JSON.stringify(fetchData), tableKey]);
  return { tableData: responseData, loading, reloadTable };
}
